/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { commonConstants } from '../constants';
import { postRequest } from '../helpers/apiUtils';

const SHORTNER_PATH = 'UAC_URL_Shortner';

function parseShortenerPayload(data) {
  if (!data) return null;
  try {
    if (typeof data.body === 'string') {
      return JSON.parse(data.body);
    }
    if (data.body && typeof data.body === 'object') {
      return data.body;
    }
    return data;
  } catch {
    return null;
  }
}

function isShortenerFailurePayload(inner) {
  return inner != null && inner.success === false;
}

/**
 * Resolve / create short URLs. Prefer .../uac/UAC_URL_Shortner; if that REST client
 * throws, or returns { success: false }, fall back to legacy .../auditor/uac/UAC_URL_Shortner.
 */
async function postUacUrlShortner(body) {
  const callLegacy = () => postRequest(commonConstants.UAC_API, SHORTNER_PATH, body);

  try {
    let data = await postRequest(
      commonConstants.UNIFIED_AUDIT_COMMUNICATION_API,
      SHORTNER_PATH,
      body
    );
    if (isShortenerFailurePayload(parseShortenerPayload(data))) {
      data = await callLegacy();
    }
    return data;
  } catch {
    return callLegacy();
  }
}

export const uacService = {
  postUacUrlShortner,
};
